import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import Input from "../input";
import DropdownComp from "../dropdown";
import { api } from '../../api';
import { EditAgentSchema } from '../../validation/ValidationSchema';
import ButtonContained from '../button';
import { getBrands,getRegionList } from '../../helpers/listsApi';
import { useNavigate,useParams} from 'react-router-dom';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import usePasswordToggle from '../hooks/usePasswordToggle';

const EditAdminAgents = (props) => {
  const token = useSelector((state) => state.auth.token);
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);
  const [PwdInputType, ToggleIcon] = usePasswordToggle();
  const navigate = useNavigate();



  const status = [
    {value: true, label: "Active"},
    {value: false, label: "Inactive"}
  ]

  const [agentRegionOptions, setAgentRegionOptions] = useState([]);
      useEffect(() => {
      const fetchData = async () => {
          try {
          const regionList = await getRegionList(null, token);

          if (regionList) {
              setAgentRegionOptions(regionList);
          } else {

              setAgentRegionOptions([]);
          }
          } catch (error) {
          setAgentRegionOptions([]);
          }
      };

      fetchData();
      }, [token]);

  const [adminData, setAdminData] = useState({});
  const [adminDataRegion, setAdminDataRegion] = useState({});

  const { id: adminId } = useParams(); 

  const getCurrentStatus = (value, list) => {
    const currentValue = list.find(lst => lst.value === value)
    return currentValue
  }


// eslint-disable-next-line
  const [brands, setBrands] = useState([])
  useEffect(() => {
    getBrands({},token).then(res => {
      setBrands(res);
    })
  }, [token])

  useEffect(() => {
    api.users
        .getUserByID({ usersId: adminId },token)
        .then((res) => {
            if (res.success === false) {
                 toast.error(res.message);
            }
            setAdminData(res.user)
            setAdminDataRegion(
            res.regions.map(region => ({
              value: region.id,
              label: region.name
            }))
           );
          
        })
        .catch((err) => {
            toast.error("Something went wrong");
            console.log(err)
        }
        );
}, [adminId,token])


  return (
    // <Modal
    //   modalHeader="Edit Admin Agent"
    //   showModal={adminModel}
    //   closeModal={closeModal}
    //   buttonText="SAVE"
    // >
      <Formik
        enableReinitialize
        validationSchema={EditAgentSchema}
        initialValues={{
          usersUserName: adminData.usersUserName,
          usersUserType: adminData.usersUserType,
          usersPhone: adminData.usersPhone,
          usersEmail: adminData.usersEmail,
          usersName: adminData.usersName,
          // usersBrand: getCurrentBrand(adminData.usersBrand, brands),
          usersPassword: adminData.usersPassword,
          confpassword: adminData.usersPassword,
          agentRegions:adminDataRegion,
          usersStatus: getCurrentStatus(adminData.usersStatus, status),
          is2faEnabled: adminData?.is2faEnabled ?? true,
        }}
        onSubmit={(values, actions) => {
          const formBody = {
            usersId: adminId,
            usersUserName: values.usersUserName,
            usersUserType: adminData.usersUserType,
            usersPhone: values.usersPhone,
            usersEmail: values.usersEmail,
            usersName: values.usersName,
            // usersBrand: values.usersBrand.value,
            usersStatus: values.usersStatus.value,
            usersPassword: values.usersPassword,
            resellerRegionId:values.agentRegions.map(region => region.value),
            is2faEnabled: values.is2faEnabled
          }
          api.users.update(formBody,token).then(res => {
            if (res.success === false) {
               toast.error(res.message);

            } else {
              toast.success(res.message);
              navigate('/admin-agent')
            }
          })
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          isSubmitting,
          setFieldValue,
        }) => {
          return (
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="box-row">

                  <div className="table-head">
                      <h1 className="sec-header">EDIT AGENT</h1>
                  </div>

                    <div className="card card-table">
                      {/* <div className="card-header card-header-title">Agent Details</div> */}
                      <div className="card-body gatepass-saveoutput">
                        <div className="reports agents">
                          <Form noValidate validated={!isValid} onSubmit={handleSubmit}>
                            <div className="form-row">
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersUserName"
                                  name="usersUserName"
                                  placeholder="User Name"
                                  type="text"
                                  label="User Name"
                                  value={values.usersName}
                                  onChange={handleChange}
                                  error={touched.usersUserName && errors.usersUserName}
                                  errorText={errors.usersUserName}
                                  disabled={true} />
                              </div>
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersPhone"
                                  name="usersPhone"
                                  placeholder="Phone Number"
                                  type="number"
                                  label="Phone"
                                  value={values.usersPhone}
                                  onChange={handleChange}
                                  error={touched.usersPhone && errors.usersPhone}
                                  errorText={errors.usersPhone}
                                  disabled={isSubmitting} />
                              </div>
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersEmail"
                                  name="usersEmail"
                                  placeholder="Email Id"
                                  label="Email"
                                  value={values.usersEmail}
                                  onChange={handleChange}
                                  error={touched.usersEmail && errors.usersEmail}
                                  errorText={errors.usersEmail}
                                  disabled={true} />
                              </div>
                            </div>
                            <div className="form-row">
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersName"
                                  name="usersName"
                                  placeholder="Name"
                                  label="Agent Name"
                                  value={values.usersName}
                                  onChange={handleChange}
                                  error={touched.usersName && errors.usersName}
                                  errorText={errors.usersName}
                                  disabled={isSubmitting} />
                              </div>
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersPassword"
                                  name="usersPassword"
                                  placeholder="Password"
                                  label="Password"
                                  type={PwdInputType}
                                  onPaste={true}
                                  autoComplete="usersPassword"
                                  value={values.usersPassword}
                                  onChange={handleChange}
                                  error={touched.usersPassword && errors.usersPassword}
                                  errorText={errors.usersPassword}
                                  disabled={isSubmitting} 
                                  isToggle={ values.usersPassword ? true: false }
                                  toggleIcon={ ToggleIcon }/>
                              </div>
                              <div className="form-group col-md-4">
                                <Input
                                  id="confpassword"
                                  name="confpassword"
                                  placeholder="Confirm Password"
                                  type="password"
                                  autoComplete="confpassword"
                                  onPaste={true}
                                  label="Confirm Password"
                                  value={values.confpassword}
                                  onChange={handleChange}
                                  error={touched.confpassword && errors.confpassword}
                                  errorText={errors.confpassword}
                                  disabled={isSubmitting} />
                              </div>
                            </div>


                            <div className="form-row">
                              
                              <div className="form-group col-md-4">
                                  <DropdownComp
                                  id="agentRegions"
                                  name="agentRegions"
                                  onChange={(selectedValue) => {
                                      setFieldValue("agentRegions", selectedValue);
                                  }}
                                  value={values.agentRegions}
                                  options={agentRegionOptions} // make sure this variable is defined
                                  label="Regions"
                                  placeholder="Please select Region"
                                  isMulti
                                  error={touched.agentRegions && errors.agentRegions}
                                  errorText={errors.agentRegions}
                                  disabled={isSubmitting}
                                  />
                              </div>
                              
                              <div className="form-group col-md-4">
                                <DropdownComp
                                  id="usersStatus"
                                  name="usersStatus"
                                  onChange={(selectedValue) => {
                                    setFieldValue("usersStatus", selectedValue)
                                  }}
                                  value={values.usersStatus}
                                  options={status}
                                  label="Status"
                                  placeholder="Status"
                                  error={touched.usersStatus && errors.usersStatus}
                                  errorText={errors.usersStatus}
                                  disabled={isSubmitting} />
                              </div>


                                 <div className="form-group col-md-4">
                                  <label htmlFor="is2faEnabled" className="d-block mb-2">
                                      Enable 2FA
                                  </label>
                                  <div className="custom-control custom-switch">
                                      <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="is2faEnabled"
                                          name="is2faEnabled"
                                          checked={values.is2faEnabled}
                                          onChange={(e) => setFieldValue("is2faEnabled", e.target.checked)}
                                          disabled={isSubmitting}
                                      />
                                      <label className="custom-control-label" htmlFor="is2faEnabled">
                                          {values.is2faEnabled ? "Enabled" : "Disabled"}
                                      </label>
                                  </div>
                              </div>


                         
                            </div>
                            <ButtonContained buttonName="Update"
                              disabled={isSubmitting} />
                          </Form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
    // </Modal>
  );
};
export default EditAdminAgents;
